import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import Modal from 'react-modal';

Modal.setAppElement(document.getElementById('root'))

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
			<App />
		</BrowserRouter>
  </React.StrictMode>
);

